import apiClient from 'apiClient';
import { AxiosPromise } from 'axios';
import { CalculationId } from '../../types';
import { Response } from './types';

const apiCall = (calculationId: CalculationId): AxiosPromise<Response> => {
  return apiClient.get(`/api/v1/af-tool/load-calculation/${calculationId}`);
};

export default apiCall;
